import { request } from "@/libs";

function fetchUsers() {
	return request(
		"/server/users",
		{ method: "GET" }
	)
		.then(res => res.json());
}

export default fetchUsers;



// WEBPACK FOOTER //
// ./src/api/fetch-users.js